import { obtenerHistorialDocente } from "../utils/docentes";
import { theme } from "../styles/theme";
import { obtenerAnioDeFecha } from "../utils/registroSchema";

const normalizarTexto = (valor) => String(valor ?? "").trim().toUpperCase();
const obtenerAnioRegistro = (item) => String(item?.anio ?? "").trim();

const escapeHtml = (valor) =>
  String(valor ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const LIMITE_TUTOR = 8;
const LIMITE_EVALUADOR = 10;

const formatearFechaEmision = () =>
  new Intl.DateTimeFormat("es-EC", {
    dateStyle: "long",
    timeStyle: "short"
  }).format(new Date());

const obtenerEstadoCarga = (actual, limite) => {
  if (actual >= limite) {
    return {
      etiqueta: "Limite alcanzado",
      clase: "status-danger"
    };
  }

  if (actual >= Math.max(limite - 2, 1)) {
    return {
      etiqueta: "Cercano al limite",
      clase: "status-warning"
    };
  }

  return {
    etiqueta: "Disponible",
    clase: "status-ok"
  };
};

const contarPorRol = (items) => ({
  tutor: items.filter((item) => item.rol === "director").length,
  evaluador: items.filter((item) => item.rol === "evaluador").length
});

const construirClaveHistorial = (item) => [item.rol, item.estudiante, item.maestria, item.cohorte, item.tema].join("|");

const contarDetallePorRol = (items) => {
  const participaciones = new Map();

  items.forEach((item) => {
    participaciones.set(construirClaveHistorial(item), item);
  });

  return Array.from(participaciones.values()).reduce(
    (acc, item) => {
      if (item.rol === "director" || item.rol === "evaluador") {
        acc[item.rol] += 1;
      }

      return acc;
    },
    {
      director: 0,
      tutor: 0,
      cotutor: 0,
      evaluador: 0,
      evaluador1: 0,
      evaluador2: 0
    }
  );
};

const ESPOL_LOGO_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190.8 42.6" aria-hidden="true">
    <g fill="#111111">
      <path d="M65.78,9.6c-4.46,0-8.07,3.61-8.07,8.07s3.61,8.07,8.07,8.07,8.07-3.61,8.07-8.07-3.61-8.07-8.07-8.07ZM65.78,22.66c-2.75,0-4.99-2.23-4.99-4.99s2.23-4.99,4.99-4.99,4.99,2.23,4.99,4.99-2.23,4.99-4.99,4.99Z"/>
      <path d="M46.41,9.62c-4.44,0-8.04,3.58-8.07,8.02h0v17.81h3.24s-.05-11.34,0-11.3c1.35,1.01,3.02,1.61,4.83,1.61,4.46,0,8.07-3.61,8.07-8.07s-3.61-8.07-8.07-8.07ZM46.41,22.68c-2.76,0-4.99-2.23-4.99-4.99s2.23-4.99,4.99-4.99,4.99,2.23,4.99,4.99-2.23,4.99-4.99,4.99Z"/>
      <path d="M85.37,22.6h0c-2.83,0-5.13-2.3-5.13-5.13V0h-3.17v17.48h0c0,4.57,3.71,8.28,8.28,8.29h0s0,0,.01,0h0c.12,0-1.04,0,1.39,0v-3.17h-1.39Z"/>
      <path d="M32.74,12.03c-2.13-2.13-5.16-2.81-7.87-2.05-.22.06-2.35.76-3.54,2.07l-9.68,8.99c-.54.51-1.03.98-1.73,1.28-.7.31-1.45.45-2.21.4-1.15-.08-2.28-.56-3.16-1.43-.68-.68-1.12-1.46-1.33-2.33h7.15l4.97-4.63c-.47-.85-1.24-1.95-1.57-2.28-3.16-3.15-8.27-3.14-11.41.02-3.15,3.16-3.14,8.27.02,11.41,2.13,2.13,5.16,2.81,7.87,2.05,1.28-.36,2.54-.98,3.55-1.98l10.21-9.49c1.96-1.7,4.69-1.69,6.55.17,1.95,1.94,1.96,5.1.01,7.05-1.39,1.4-3.4,1.8-5.15,1.2v3.19c2.58.52,5.35-.22,7.33-2.21,3.15-3.16,3.14-8.27-.02-11.41ZM4.59,14.14c.91-.89,2.15-1.43,3.52-1.42h0c1.42,0,2.7.62,3.6,1.58l-1.98,1.8H3.37c.26-.73.68-1.42,1.22-1.95Z"/>
      <path d="M94.62,10.93v1.32h2.21v1.24h-2.21v1.32h2.56v1.24h-3.97v-6.35h3.97v1.24h-2.56Z"/>
      <path d="M97.81,15.47l.56-.91c.36.26.96.48,1.42.48.39,0,.64-.16.64-.41,0-.34-.46-.38-1.08-.55-.65-.18-1.37-.46-1.37-1.33,0-.96.89-1.41,1.9-1.41.64,0,1.26.18,1.71.48l-.57.82c-.35-.21-.88-.38-1.25-.38-.34,0-.54.13-.54.34,0,.33.51.41,1.05.55.85.21,1.43.53,1.43,1.39,0,.99-.76,1.53-1.9,1.53-.88,0-1.58-.31-2-.58Z"/>
      <path d="M102.28,13.7c0-1.32,1.03-2.36,2.42-2.36.99,0,1.83.58,2.18,1.43l-1.13.48c-.17-.41-.56-.7-1.05-.7-.65,0-1.14.5-1.14,1.15s.49,1.14,1.14,1.14c.49,0,.87-.28,1.05-.69l1.13.47c-.35.86-1.18,1.43-2.18,1.43-1.39,0-2.42-1.04-2.42-2.35Z"/>
      <path d="M107.63,14.23v-2.81h1.36v2.7c0,.51.3.78.72.78s.73-.26.73-.78v-2.7h1.36v2.81c0,1.11-.75,1.82-2.08,1.82s-2.07-.71-2.07-1.82Z"/>
      <path d="M117.37,13.95h-3.39c.09.66.52,1.04,1.1,1.04.44,0,.83-.2,1.05-.6l1.07.44c-.35.75-1.12,1.22-2.11,1.22-1.49,0-2.47-1.04-2.47-2.35s1-2.37,2.41-2.37c1.31,0,2.33.9,2.33,2.31v.3ZM114.05,13.08h1.93c-.14-.45-.43-.71-.93-.71s-.85.27-1,.71Z"/>
      <path d="M118.31,9.7h1.36v6.35h-1.36v-6.35Z"/>
      <path d="M125.61,11.42v4.54h-1.25l-.05-.62c-.31.41-.78.72-1.5.72-1.18,0-2.18-.99-2.18-2.38s1-2.37,2.18-2.37c.66,0,1.12.26,1.43.64v-.53h1.36ZM124.34,13.67c0-.66-.52-1.19-1.17-1.19s-1.16.52-1.16,1.19.51,1.2,1.16,1.2,1.17-.53,1.17-1.2Z"/>
      <path d="M128.65,14.94l.91-.94c.44.56.89.86,1.48.86.51,0,.79-.24.79-.64,0-.52-.56-.71-1.23-.98-.76-.3-1.67-.72-1.67-1.86s.95-1.78,2.03-1.78c.86,0,1.52.4,2.03.92l-.85.84c-.44-.5-.84-.63-1.18-.63-.36,0-.65.2-.65.53,0,.46.56.64,1.15.89.81.33,1.74.79,1.74,1.98s-1.01,1.9-2.15,1.9-1.99-.62-2.39-1.1Z"/>
      <path d="M133.97,14.23v-2.81h1.36v2.7c0,.51.3.78.72.78s.73-.26.73-.78v-2.7h1.36v2.81c0,1.11-.75,1.82-2.08,1.82s-2.07-.71-2.07-1.82Z"/>
      <path d="M144.33,13.7c0,1.38-1,2.37-2.18,2.37-.66,0-1.12-.26-1.43-.64v2.85h-1.36v-6.86h1.24l.05.63c.31-.41.78-.72,1.5-.72,1.18,0,2.18.99,2.18,2.37ZM142.97,13.7c0-.66-.51-1.19-1.16-1.19s-1.17.53-1.17,1.19.52,1.19,1.17,1.19,1.16-.52,1.16-1.19Z"/>
      <path d="M149.65,13.94h-3.39c.09.66.52,1.04,1.1,1.04.44,0,.83-.2,1.05-.6l1.07.44c-.35.75-1.12,1.22-2.11,1.22-1.49,0-2.47-1.04-2.47-2.35s1-2.37,2.41-2.37c1.31,0,2.33.9,2.33,2.31v.3ZM146.33,13.08h1.93c-.14-.45-.43-.71-.93-.71s-.85.27-1,.71Z"/>
      <path d="M153.93,11.56l-.46,1.16c-.15-.08-.32-.13-.47-.13-.57,0-1.05.49-1.05,1.28v2.08h-1.36v-4.54h1.36v.73c.25-.5.66-.82,1.25-.82.31,0,.54.09.73.24Z"/>
      <path d="M154.53,9.88c0-.42.34-.75.76-.75s.76.33.76.75-.35.76-.76.76-.76-.34-.76-.76ZM154.61,11.42h1.35v4.54h-1.35v-4.54Z"/>
      <path d="M156.91,13.69c0-1.32,1.03-2.36,2.42-2.36s2.42,1.04,2.42,2.36-1.04,2.35-2.42,2.35-2.42-1.04-2.42-2.35ZM160.44,13.69c0-.68-.5-1.17-1.12-1.17s-1.12.48-1.12,1.17.49,1.16,1.12,1.16,1.12-.49,1.12-1.16Z"/>
      <path d="M166.03,11.56l-.46,1.16c-.15-.08-.32-.13-.47-.13-.57,0-1.05.49-1.05,1.28v2.08h-1.36v-4.54h1.36v.73c.25-.5.66-.82,1.25-.82.31,0,.54.09.73.24Z"/>
      <path d="M98.2,21.3c0,1.08-.84,1.89-1.92,1.89h-1.65v2.59h-1.42v-6.42h3.07c1.08,0,1.92.86,1.92,1.93ZM96.84,21.31c0-.42-.33-.7-.79-.7h-1.42v1.4h1.42c.45,0,.79-.28.79-.7Z"/>
      <path d="M98.39,23.49c0-1.33,1.04-2.38,2.44-2.38s2.44,1.05,2.44,2.38-1.05,2.38-2.44,2.38-2.44-1.05-2.44-2.38ZM101.96,23.49c0-.69-.5-1.18-1.13-1.18s-1.13.49-1.13,1.18.5,1.17,1.13,1.17,1.13-.49,1.13-1.17Z"/>
      <path d="M104.23,19.36h1.38v6.42h-1.38v-6.42Z"/>
      <path d="M106.88,19.65c0-.42.35-.76.77-.76s.77.34.77.76-.35.77-.77.77-.77-.35-.77-.77ZM106.96,21.19h1.37v4.58h-1.37v-4.58Z"/>
      <path d="M112.24,22.26h-.86v3.52h-1.38v-3.52h-.87v-1.07h.87v-1.65h1.38v1.65h.86v1.07Z"/>
      <path d="M117.4,23.74h-3.42c.09.67.52,1.05,1.11,1.05.44,0,.84-.2,1.06-.6l1.08.45c-.36.76-1.13,1.23-2.13,1.23-1.51,0-2.49-1.05-2.49-2.37s1.01-2.39,2.44-2.39c1.32,0,2.35.91,2.35,2.33v.3ZM114.05,22.87h1.95c-.14-.45-.44-.72-.94-.72s-.86.27-1.01.72ZM115.02,20.69l-.5-.55,1.47-1.59.66.74-1.63,1.4Z"/>
      <path d="M117.94,23.49c0-1.33,1.04-2.38,2.44-2.38,1,0,1.85.59,2.2,1.45l-1.14.48c-.18-.42-.57-.7-1.06-.7-.66,0-1.15.5-1.15,1.16s.49,1.15,1.15,1.15c.49,0,.88-.28,1.06-.7l1.14.48c-.35.87-1.2,1.45-2.2,1.45-1.4,0-2.44-1.05-2.44-2.38Z"/>
      <path d="M127.76,22.84v2.94h-1.37v-2.76c0-.45-.32-.74-.76-.74-.46,0-.79.33-.79.79v2.71h-1.38v-4.58h1.38v.47c.33-.37.79-.55,1.28-.55.91,0,1.64.75,1.64,1.73Z"/>
      <path d="M128.92,19.65c0-.42.35-.76.77-.76s.77.34.77.76-.35.77-.77.77-.77-.35-.77-.77ZM129,21.19h1.37v4.58h-1.37v-4.58Z"/>
      <path d="M131.32,23.49c0-1.33,1.04-2.38,2.44-2.38,1,0,1.85.59,2.2,1.45l-1.14.48c-.18-.42-.57-.7-1.06-.7-.66,0-1.15.5-1.15,1.16s.49,1.15,1.15,1.15c.49,0,.88-.28,1.06-.7l1.14.48c-.35.87-1.2,1.45-2.2,1.45-1.4,0-2.44-1.05-2.44-2.38Z"/>
      <path d="M141.48,21.19v4.58h-1.26l-.05-.63c-.31.41-.79.72-1.51.72-1.19,0-2.2-1-2.2-2.4s1.01-2.39,2.2-2.39c.67,0,1.13.27,1.44.65v-.54h1.38ZM140.19,23.47c0-.67-.52-1.2-1.18-1.2s-1.18.53-1.18,1.2.52,1.21,1.18,1.21,1.18-.54,1.18-1.21Z"/>
      <path d="M149.85,19.36v6.42h-1.26l-.05-.63c-.31.41-.79.72-1.51.72-1.19,0-2.2-1-2.2-2.4s1.01-2.39,2.2-2.39c.67,0,1.13.27,1.44.65v-2.37h1.38ZM148.57,23.47c0-.67-.52-1.2-1.18-1.2s-1.18.53-1.18,1.2.52,1.21,1.18,1.21,1.18-.54,1.18-1.21Z"/>
      <path d="M155.6,23.74h-3.42c.09.67.52,1.05,1.11,1.05.44,0,.84-.2,1.06-.6l1.08.45c-.36.76-1.13,1.23-2.13,1.23-1.51,0-2.49-1.05-2.49-2.37s1.01-2.39,2.44-2.39c1.32,0,2.35.91,2.35,2.33v.3ZM152.25,22.87h1.95c-.14-.45-.44-.72-.94-.72s-.86.27-1.01.72Z"/>
      <path d="M156.55,19.36h1.38v6.42h-1.38v-6.42Z"/>
      <path d="M164.44,24.56v1.22h-3.44v-6.42h1.38v5.2h2.06Z"/>
      <path d="M165.09,19.65c0-.42.35-.76.77-.76s.77.34.77.76-.35.77-.77.77-.77-.35-.77-.77ZM165.17,21.19h1.37v4.58h-1.37v-4.58Z"/>
      <path d="M170.44,22.26h-.86v3.52h-1.38v-3.52h-.87v-1.07h.87v-1.65h1.38v1.65h.86v1.07Z"/>
      <path d="M170.81,23.49c0-1.33,1.04-2.38,2.44-2.38s2.44,1.05,2.44,2.38-1.05,2.38-2.44,2.38-2.44-1.05-2.44-2.38ZM174.38,23.49c0-.69-.5-1.18-1.13-1.18s-1.13.49-1.13,1.18.5,1.17,1.13,1.17,1.13-.49,1.13-1.17Z"/>
      <path d="M180.02,21.34l-.47,1.18c-.15-.09-.32-.13-.48-.13-.57,0-1.06.5-1.06,1.29v2.1h-1.38v-4.58h1.38v.74c.25-.5.67-.83,1.26-.83.31,0,.55.09.74.24Z"/>
      <path d="M185.18,21.19v4.58h-1.26l-.05-.63c-.31.41-.79.72-1.51.72-1.19,0-2.2-1-2.2-2.4s1.01-2.39,2.2-2.39c.67,0,1.13.27,1.44.65v-.54h1.38ZM183.89,23.47c0-.67-.52-1.2-1.18-1.2s-1.18.53-1.18,1.2.52,1.21,1.18,1.21,1.18-.54,1.18-1.21Z"/>
      <path d="M186.54,19.36h1.38v6.42h-1.38v-6.42Z"/>
    </g>
  </svg>
`;

const construirInformeHtml = ({ docente, detalle, historialGraduados, historialAsignados, anioSeleccionado }) => {
  const estadoTutor = obtenerEstadoCarga(detalle.director, LIMITE_TUTOR);
  const estadoEvaluador = obtenerEstadoCarga(detalle.evaluador, LIMITE_EVALUADOR);
  const totalParticipaciones = detalle.director + detalle.evaluador;
  const resumenPeriodo = anioSeleccionado || "No especificado";
  const resumenGraduados = contarPorRol(historialGraduados);
  const resumenAsignados = contarPorRol(historialAsignados);
  const conclusion = [
    detalle.director >= LIMITE_TUTOR
      ? "El docente alcanzo el limite anual de participaciones como Tutor."
      : `El docente mantiene ${Math.max(LIMITE_TUTOR - detalle.director, 0)} participaciones disponibles como Tutor.`,
    detalle.evaluador >= LIMITE_EVALUADOR
      ? "El docente alcanzo el limite anual de participaciones como Evaluador."
      : `El docente mantiene ${Math.max(LIMITE_EVALUADOR - detalle.evaluador, 0)} participaciones disponibles como Evaluador.`
  ].join(" ");

  const renderParticipaciones = (items) => {
    if (items.length === 0) {
      return `
        <section class="section">
          <p class="empty">No se registran participaciones en esta categoria.</p>
        </section>
      `;
    }

    return `
      <section class="section">
        <table class="report-table">
          <thead>
            <tr>
              <th>Estudiante</th>
              <th>Programa</th>
              <th>Cohorte</th>
              <th>Rol</th>
              <th>Estado</th>
              <th>Proyecto</th>
            </tr>
          </thead>
          <tbody>
            ${items
              .map(
                (item) => `
                  <tr>
                    <td>${escapeHtml(item.estudiante)}</td>
                    <td>${escapeHtml(item.maestria)}</td>
                    <td>${escapeHtml(item.cohorte)}</td>
                    <td>${escapeHtml(item.rolLabel)}</td>
                    <td>${escapeHtml(item.estado)}</td>
                    <td>${escapeHtml(item.tema || "Sin tema registrado")}</td>
                  </tr>
                `
              )
              .join("")}
          </tbody>
        </table>
      </section>
    `;
  };

  return `
    <!DOCTYPE html>
    <html lang="es">
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Informe docente - ${escapeHtml(docente)}</title>
        <style>
          :root {
            color-scheme: light;
          }
          * {
            box-sizing: border-box;
          }
          @page {
            size: A4 portrait;
            margin: 18mm 16mm 18mm 16mm;
          }
          body {
            font-family: Aptos, Arial, sans-serif;
            margin: 0;
            color: #233441;
            background: #ffffff;
          }
          .page-header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            background: #ffffff;
            padding: 10px 14mm 8px;
            border-bottom: 1px solid #d8e1ea;
            z-index: 10;
          }
          .page-header-inner {
            max-width: 820px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            gap: 20px;
          }
          .page-header-brand {
            display: flex;
            align-items: center;
            min-width: 0;
            flex: 0 0 285px;
          }
          .espol-logo {
            width: 100%;
            display: block;
          }
          .espol-logo svg {
            display: block;
            width: 100%;
            height: auto;
          }
          .campus-line {
            flex: 1 1 auto;
            text-align: center;
            font-size: 10.6px;
            font-weight: 700;
            color: #111111;
            line-height: 1.2;
            padding: 0 6px 3px;
            white-space: nowrap;
          }
          .page-header-meta {
            text-align: right;
            font-size: 10.8px;
            font-weight: 700;
            color: #111111;
            line-height: 1.2;
            flex: 0 0 135px;
            white-space: nowrap;
          }
          .report-shell {
            max-width: 820px;
            margin: 0 auto;
            padding: 86px 0 22px;
          }
          .cover-page {
            min-height: auto;
          }
          .faculty-title {
            margin: 0 0 10px;
            text-align: center;
            font-size: 16px;
            font-weight: 800;
            color: #233441;
            text-transform: uppercase;
            letter-spacing: 0.02em;
          }
          .report-title {
            margin: 0 0 20px;
            text-align: center;
            font-size: 20px;
            font-weight: 800;
            color: #15437a;
            text-transform: uppercase;
            letter-spacing: 0.04em;
          }
          .doc-meta {
            display: grid;
            grid-template-columns: minmax(260px, 1.2fr) minmax(260px, 1fr);
            gap: 18px;
            align-items: start;
            margin-bottom: 16px;
          }
          .doc-meta-card,
          .meta-box {
            border: 1px solid #d8e1ea;
            border-radius: 14px;
            background: #f8fafc;
            padding: 16px 18px;
          }
          .doc-meta-card-title {
            margin: 0 0 8px;
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            color: #60707b;
          }
          .doc-meta-card-value {
            margin: 0;
            font-size: 18px;
            font-weight: 800;
            color: #15437a;
            line-height: 1.35;
          }
          .meta-box {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .meta-row {
            display: grid;
            grid-template-columns: 1fr auto;
            gap: 16px;
            font-size: 13px;
            padding-bottom: 10px;
            border-bottom: 1px solid #e8edf2;
          }
          .meta-row:last-child {
            padding-bottom: 0;
            border-bottom: none;
          }
          .summary {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 16px;
            margin-bottom: 14px;
          }
          .summary-card {
            border: 1px solid #c8d2de;
            border-radius: 12px;
            padding: 13px 15px;
            background: #f8fafc;
            min-width: 180px;
          }
          .summary-label {
            display: block;
            font-size: 12px;
            font-weight: 700;
            color: #60707b;
            margin-bottom: 8px;
            text-transform: uppercase;
            letter-spacing: 0.04em;
          }
          .summary-value {
            font-size: 24px;
            font-weight: 800;
            color: #15437a;
          }
          .summary-inline {
            font-size: 12px;
            color: #60707b;
            margin-top: 4px;
          }
          .status-chip {
            display: inline-block;
            margin-top: 8px;
            padding: 5px 10px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
          }
          .status-ok {
            background: #e7f6ec;
            color: #1d6b3b;
          }
          .status-warning {
            background: #fff4dc;
            color: #8a6116;
          }
          .status-danger {
            background: #fde8e8;
            color: #b42318;
          }
          .distribution-panel {
            border: 1px solid #d8e1ea;
            border-radius: 16px;
            overflow: hidden;
            background: #ffffff;
          }
          .distribution-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            padding: 14px 16px;
            background: linear-gradient(135deg, #f8fbff, #f1f6fb);
            border-bottom: 1px solid #d8e1ea;
          }
          .distribution-title {
            margin: 0;
            font-size: 15px;
            font-weight: 800;
            color: #15437a;
          }
          .distribution-subtitle {
            margin: 4px 0 0;
            font-size: 11px;
            color: #60707b;
          }
          .distribution-total {
            padding: 7px 11px;
            border-radius: 999px;
            background: #e8f0fb;
            color: #15437a;
            font-size: 11px;
            font-weight: 800;
            white-space: nowrap;
          }
          .distribution-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
          .distribution-card {
            padding: 14px;
            border-right: 1px solid #e8edf2;
          }
          .distribution-card:last-child {
            border-right: none;
          }
          .distribution-card-title {
            margin: 0 0 12px;
            font-size: 13px;
            font-weight: 800;
            color: #15437a;
          }
          .distribution-stats {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 8px;
          }
          .distribution-stat {
            padding: 10px 12px;
            border: 1px solid #d8e1ea;
            border-radius: 12px;
            background: #fbfdff;
          }
          .distribution-stat-label {
            display: block;
            margin-bottom: 4px;
            color: #60707b;
            font-size: 10px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.04em;
          }
          .distribution-stat-value {
            font-size: 20px;
            font-weight: 800;
            color: #15437a;
          }
          .distribution-stat-value.accent {
            color: #b08d2f;
          }
          .report-page-start {
            break-before: page;
            page-break-before: always;
            padding-top: 8px;
          }
          .report-page {
            padding-top: 8px;
          }
          .page-section-title {
            margin: 0 0 12px;
            font-size: 20px;
            font-weight: 800;
            color: #15437a;
          }
          .page-section-subtitle {
            margin: 0 0 18px;
            font-size: 13px;
            color: #60707b;
            line-height: 1.5;
          }
          .section {
            margin-top: 0;
          }
          .report-table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #d8e1ea;
            border-radius: 12px;
            overflow: hidden;
          }
          .report-table th,
          .report-table td {
            border-bottom: 1px solid #e8edf2;
            padding: 10px 12px;
            text-align: left;
            vertical-align: top;
            font-size: 12px;
            line-height: 1.45;
          }
          .report-table th {
            background: #f1f6fb;
            color: #15437a;
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.03em;
          }
          .report-table tr:nth-child(even) td {
            background: #fbfdff;
          }
          .empty {
            color: #60707b;
          }
          .footer-note {
            margin-top: 28px;
            padding-top: 14px;
            border-top: 1px solid #d8e1ea;
            color: #60707b;
            font-size: 12px;
            line-height: 1.5;
          }
          @media screen and (max-width: 860px) {
            .doc-meta {
              grid-template-columns: 1fr;
            }
            .page-header-inner {
              flex-direction: column;
              align-items: flex-start;
            }
            .campus-line,
            .page-header-meta {
              text-align: left;
              padding: 0;
            }
            .summary,
            .distribution-grid {
              grid-template-columns: 1fr;
            }
            .distribution-card {
              border-right: none;
              border-bottom: 1px solid #e8edf2;
            }
            .distribution-card:last-child {
              border-bottom: none;
            }
          }
          @media print {
            .page-header {
              position: fixed;
            }
            .report-shell {
              max-width: none;
            }
            .page-header-inner {
              flex-direction: row;
              align-items: flex-end;
              gap: 14px;
            }
            .page-header-brand {
              flex: 0 0 255px;
            }
            .espol-logo {
              width: 255px;
            }
            .campus-line {
              text-align: center;
              font-size: 10px;
              padding: 0 4px 2px;
              white-space: nowrap;
            }
            .page-header-meta {
              flex: 0 0 128px;
              font-size: 10px;
              text-align: right;
              white-space: nowrap;
            }
            .doc-meta {
              grid-template-columns: minmax(250px, 1.2fr) minmax(250px, 1fr);
              gap: 16px;
            }
            .summary {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
            .distribution-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
            .distribution-card {
              border-right: 1px solid #e8edf2;
              border-bottom: none;
            }
            .cover-page {
              min-height: auto;
              page-break-after: avoid;
            }
            .report-page-start {
              break-before: page;
              page-break-before: always;
              padding-top: 74px;
            }
            .report-page {
              padding-top: 74px;
            }
            .report-page,
            .report-table,
            .report-table tbody,
            .report-table tr {
              break-inside: auto;
              page-break-inside: auto;
            }
            .report-page:last-of-type,
            .report-page-start:last-of-type {
              break-after: auto;
              page-break-after: auto;
            }
            .footer-note {
              page-break-inside: avoid;
            }
          }
        </style>
      </head>
      <body>
        <header class="page-header">
          <div class="page-header-inner">
            <div class="page-header-brand">
              <div class="espol-logo">${ESPOL_LOGO_SVG}</div>
            </div>
            <div class="campus-line">Campus Gustavo Galindo Velasco - Km. 30.5 Via Perimetral - Pbx: (593-4) 2269 269</div>
            <div class="page-header-meta">Guayaquil - Ecuador</div>
          </div>
        </header>

        <div class="report-shell">
          <section class="cover-page">
            <h1 class="faculty-title">FACULTAD DE INGENIERIA EN ELECTRICIDAD Y COMPUTACION</h1>
            <div class="report-title">INFORME DE PARTICIPACIONES DOCENTES</div>

            <div class="doc-meta">
              <div class="doc-meta-card">
                <p class="doc-meta-card-title">Docente analizado</p>
                <p class="doc-meta-card-value">${escapeHtml(docente)}</p>
              </div>
              <div class="meta-box">
                <div class="meta-row"><strong>Periodo analizado</strong><span>${escapeHtml(resumenPeriodo)}</span></div>
                <div class="meta-row"><strong>Fecha de emision</strong><span>${escapeHtml(formatearFechaEmision())}</span></div>
                <div class="meta-row"><strong>Total de participaciones</strong><span>${totalParticipaciones}</span></div>
              </div>
            </div>

            <div class="summary">
              <div class="summary-card">
                <span class="summary-label">Participaciones como tutor</span>
                <span class="summary-value">${detalle.director}</span>
                <div class="summary-inline">Limite anual: ${LIMITE_TUTOR}</div>
                <div class="summary-inline">Disponibilidad: ${Math.max(LIMITE_TUTOR - detalle.director, 0)}</div>
                <span class="status-chip ${estadoTutor.clase}">${estadoTutor.etiqueta}</span>
              </div>
              <div class="summary-card">
                <span class="summary-label">Participaciones como evaluador</span>
                <span class="summary-value">${detalle.evaluador}</span>
                <div class="summary-inline">Limite anual: ${LIMITE_EVALUADOR}</div>
                <div class="summary-inline">Disponibilidad: ${Math.max(LIMITE_EVALUADOR - detalle.evaluador, 0)}</div>
                <span class="status-chip ${estadoEvaluador.clase}">${estadoEvaluador.etiqueta}</span>
              </div>
            </div>

            <section class="distribution-panel">
              <div class="distribution-header">
                <div>
                  <h2 class="distribution-title">Distribucion de participaciones por categoria</h2>
                  <p class="distribution-subtitle">
                    Desglose de roles de Tutor y Evaluador segun graduaciones y asignaciones del periodo.
                  </p>
                </div>
                <span class="distribution-total">Total analizado: ${totalParticipaciones}</span>
              </div>
              <div class="distribution-grid">
                <article class="distribution-card">
                  <h3 class="distribution-card-title">Estudiantes graduados en el a&ntilde;o ${escapeHtml(resumenPeriodo)}</h3>
                  <div class="distribution-stats">
                    <div class="distribution-stat">
                      <span class="distribution-stat-label">Tutor</span>
                      <span class="distribution-stat-value">${resumenGraduados.tutor}</span>
                    </div>
                    <div class="distribution-stat">
                      <span class="distribution-stat-label">Evaluador</span>
                      <span class="distribution-stat-value accent">${resumenGraduados.evaluador}</span>
                    </div>
                  </div>
                </article>
                <article class="distribution-card">
                  <h3 class="distribution-card-title">Asignados en el a&ntilde;o ${escapeHtml(resumenPeriodo)}</h3>
                  <div class="distribution-stats">
                    <div class="distribution-stat">
                      <span class="distribution-stat-label">Tutor</span>
                      <span class="distribution-stat-value">${resumenAsignados.tutor}</span>
                    </div>
                    <div class="distribution-stat">
                      <span class="distribution-stat-label">Evaluador</span>
                      <span class="distribution-stat-value accent">${resumenAsignados.evaluador}</span>
                    </div>
                  </div>
                </article>
              </div>
            </section>
          </section>

          <section class="report-page-start">
            <h2 class="page-section-title">Participaciones con estudiantes graduados en el a&ntilde;o ${escapeHtml(resumenPeriodo)}</h2>
            <p class="page-section-subtitle">
              Detalle de participaciones registradas del docente analizado en proyectos cuyo estado corresponde a estudiantes graduados dentro del periodo analizado.
            </p>
            ${renderParticipaciones(historialGraduados)}
          </section>

          <section class="report-page">
            <h2 class="page-section-title">Participaciones asignadas en el a&ntilde;o ${escapeHtml(resumenPeriodo)}</h2>
            <p class="page-section-subtitle">
              Detalle de participaciones registradas del docente analizado en proyectos asignados durante el a&ntilde;o seleccionado.
            </p>
            ${renderParticipaciones(historialAsignados)}

            <footer class="footer-note">
              <strong>Conclusion:</strong> ${escapeHtml(conclusion)}
              <br />
              Fuente de datos: Plataforma de Postgrados FIEC con base en registros centralizados en Google Sheets.
            </footer>
          </section>
        </div>
      </body>
    </html>
  `;
};

function ModalDetalle({ docente, data, anioSeleccionado, onClose }) {
  const dataAsignados = data.filter((item) => obtenerAnioRegistro(item) === anioSeleccionado);
  const dataGraduados = data.filter(
    (item) =>
      normalizarTexto(item?.estado) === "GRADUADO" &&
      obtenerAnioDeFecha(item?.fecha_graduacion) === anioSeleccionado
  );

  const historialAsignados = obtenerHistorialDocente(dataAsignados, docente).filter(
    (participacion) => participacion.rol === "director" || participacion.rol === "evaluador"
  );
  const historialGraduados = obtenerHistorialDocente(dataGraduados, docente).filter(
    (participacion) => participacion.rol === "director" || participacion.rol === "evaluador"
  );
  const detalle = contarDetallePorRol([...historialGraduados, ...historialAsignados]);

  const exportarInforme = () => {
    const html = construirInformeHtml({
      docente,
      detalle,
      historialGraduados,
      historialAsignados,
      anioSeleccionado
    });

    const blob = new Blob([html], { type: "text/html;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const popup = window.open(url, "_blank", "width=1100,height=800");

    if (!popup) {
      URL.revokeObjectURL(url);
      window.alert("No se pudo abrir la ventana de exportacion. Revisa si el navegador bloqueo los popups.");
      return;
    }

    const liberarUrl = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 60000);
    };

    popup.onload = () => {
      popup.focus();
      setTimeout(() => {
        popup.print();
        liberarUrl();
      }, 350);
    };
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <div style={styles.header}>
          <div>
            <h2 style={styles.title}>{docente}</h2>
            <p style={styles.subtitle}>Detalle historico de participaciones por rol y estudiante del año {anioSeleccionado}.</p>
          </div>

          <div style={styles.headerActions}>
            <button onClick={exportarInforme} style={styles.primaryButton}>Exportar informe</button>
            <button onClick={onClose} style={styles.closeButton}>Cerrar</button>
          </div>
        </div>

        <div style={styles.summaryGrid}>
          <div style={styles.summaryCard}>
            <span style={styles.summaryLabel}>Tutor</span>
            <strong style={styles.summaryValue}>{detalle.director}</strong>
          </div>
          <div style={styles.summaryCard}>
            <span style={styles.summaryLabel}>Evaluador</span>
            <strong style={styles.summaryValueAlt}>{detalle.evaluador}</strong>
          </div>
        </div>

        <SectionParticipaciones titulo="Participaciones con estudiantes graduados" items={historialGraduados} />
        <SectionParticipaciones titulo="Participaciones asignadas en el año" items={historialAsignados} />
      </div>
    </div>
  );
}

function SectionParticipaciones({ titulo, items }) {
  return (
    <section style={styles.section}>
      <h3 style={styles.sectionTitle}>{titulo}</h3>
      <div style={styles.history}>
        {items.length > 0 ? (
          items.map((participacion, index) => (
            <article key={`${participacion.estudiante}-${participacion.rol}-${index}`} style={styles.historyCard}>
              <div style={styles.historyTop}>
                <strong style={styles.student}>{participacion.estudiante}</strong>
                <span style={styles.roleBadge}>{participacion.rolLabel}</span>
              </div>
              <p style={styles.meta}>
                {participacion.maestria} | Cohorte {participacion.cohorte} | {participacion.estado}
              </p>
              {participacion.tema && <p style={styles.topic}>{participacion.tema}</p>}
              {(participacion.fechaTentativa || participacion.fechaGraduacion) && (
                <p style={styles.meta}>
                  {participacion.fechaGraduacion
                    ? `Graduacion: ${participacion.fechaGraduacion}`
                    : `Fecha tentativa: ${participacion.fechaTentativa}`}
                </p>
              )}
            </article>
          ))
        ) : (
          <p style={styles.empty}>No hay participaciones en esta categoria.</p>
        )}
      </div>
    </section>
  );
}

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: theme.colors.overlay,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const modal = {
  background: theme.colors.panelBg,
  padding: "24px",
  borderRadius: "16px",
  color: theme.colors.text,
  border: `1px solid ${theme.colors.border}`,
  boxShadow: "0 24px 80px rgba(15, 23, 42, 0.18)",
  width: "min(980px, 100%)",
  maxHeight: "88vh",
  overflowY: "auto"
};

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
    marginBottom: "20px"
  },
  title: {
    margin: 0
  },
  subtitle: {
    margin: "8px 0 0",
    color: theme.colors.subtext
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },
  closeButton: {
    background: "transparent",
    border: `1px solid ${theme.colors.border}`,
    color: theme.colors.text,
    borderRadius: "10px",
    padding: "10px 14px",
    cursor: "pointer"
  },
  primaryButton: {
    background: `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.headerEnd})`,
    border: "none",
    color: "#fff",
    borderRadius: "10px",
    padding: "10px 14px",
    cursor: "pointer",
    fontWeight: 700
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
    gap: "14px",
    marginBottom: "20px"
  },
  summaryCard: {
    background: "#f8fafc",
    border: `1px solid ${theme.colors.border}`,
    borderRadius: "14px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  },
  summaryLabel: {
    color: theme.colors.subtext,
    fontSize: "13px",
    fontWeight: 700
  },
  summaryValue: {
    fontSize: "24px",
    color: theme.colors.primary
  },
  summaryValueAlt: {
    fontSize: "24px",
    color: theme.colors.accent
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    marginBottom: "20px"
  },
  sectionTitle: {
    margin: 0,
    color: theme.colors.text,
    fontSize: "18px"
  },
  history: {
    display: "grid",
    gap: "14px"
  },
  historyCard: {
    border: `1px solid ${theme.colors.border}`,
    borderRadius: "16px",
    padding: "16px",
    background: theme.colors.panelBg,
    boxShadow: "0 10px 24px rgba(18, 38, 63, 0.06)"
  },
  historyTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "8px"
  },
  student: {
    color: theme.colors.text
  },
  roleBadge: {
    padding: "6px 10px",
    borderRadius: "999px",
    background: theme.colors.primarySoft,
    color: theme.colors.primary,
    fontWeight: 700,
    fontSize: "12px"
  },
  meta: {
    margin: "0 0 8px",
    color: theme.colors.subtext,
    fontSize: "13px"
  },
  topic: {
    margin: "0 0 8px",
    color: theme.colors.text,
    lineHeight: 1.5
  },
  empty: {
    margin: 0,
    color: theme.colors.subtext
  }
};

export default ModalDetalle;
